var EMAIL_TYPE='EMAIL';var SMS_TYPE='SMS';export{EMAIL_TYPE,SMS_TYPE};
//# sourceMappingURL=optInTypes.js.map